import {useLayoutStore} from '~/store/layout'

declare module 'vue-router' {
    interface RouteMeta {
        module?: string
    }
}

export default defineNuxtRouteMiddleware((to) => {
    useLayoutStore().setCurrentModule(to.meta?.module || 'dashboard')
})